import axios from "axios";
import { toast } from "react-toastify";

let hasHandledSessionExpiry = false;

const isExpiredMessage = (message) => {
  if (!message) return false;
  const normalized = String(message).toLowerCase();
  return (
    normalized.includes("token is expired") ||
    normalized.includes("idx10223") ||
    normalized.includes("lifetime validation failed")
  );
};

const extractResponseMeta = (data) => {
  if (!data) {
    return { respCode: undefined, respMessage: "" };
  }
  if (data.baseResponseModel) {
    return {
      respCode: data.baseResponseModel.respCode ?? data.baseResponseModel.RespCode,
      respMessage:
        data.baseResponseModel.respMessage ??
        data.baseResponseModel.RespMessage,
    };
  }
  return {
    respCode: data.respCode ?? data.RespCode,
    respMessage: data.respMessage ?? data.RespMessage,
  };
};

const handleSessionExpired = (message) => {
  if (hasHandledSessionExpiry) {
    return;
  }
  hasHandledSessionExpiry = true;
  sessionStorage.clear();
  toast.error(message || "Session expired. Please login again.");
  const isAdminPath = window.location.pathname.startsWith("/admin");
  const redirectPath = isAdminPath ? "/admin/login" : "/auth?type=logIn";
  window.location.replace(redirectPath);
};

const shouldHandleSessionExpiry = (data, status) => {
  const { respCode, respMessage } = extractResponseMeta(data);
  if (status === 401 || respCode === 401) {
    return true;
  }
  return isExpiredMessage(respMessage);
};

axios.interceptors.response.use(
  (response) => {
    if (shouldHandleSessionExpiry(response?.data, response?.status)) {
      const { respMessage } = extractResponseMeta(response?.data);
      handleSessionExpired(respMessage);
    }
    return response;
  },
  (error) => {
    if (shouldHandleSessionExpiry(error?.response?.data, error?.response?.status)) {
      const { respMessage } = extractResponseMeta(error?.response?.data);
      handleSessionExpired(respMessage);
    }
    return Promise.reject(error);
  }
);

export default axios;
